import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import styled from 'styled-components';

const StyledValuationCell = styled.td`
  width: 7rem;
`;
const StyledSpotCell = styled.td`
  width: 6.5rem;
`;
const StyledStrike = styled.td`
  width: 6.5rem;
`;

export const DataSkeleton: FC<{}> = () => (
  <>
    <StyledStrike className="border ps-2 align-middle">
      <Skeleton width="3rem" />
    </StyledStrike>
    <StyledSpotCell className="border ps-2 align-middle">
      <Skeleton className="ms-1" width="1rem" />
      <Skeleton className="ms-2" width="3rem" />
    </StyledSpotCell>
    <StyledValuationCell className="border ps-2 align-middle">
      <Skeleton className="ms-2" width="6rem" />
    </StyledValuationCell>
  </>
);
